export default __webpack_public_path__ + "static/media/roof-dev.4e7a6a3c.jpg";